"use client";
import React from "react";
import { Boxes } from "../components/ui/bgboxes";
import { cn } from "../lib/utils";

export function BackgroundBoxesDemo() {
  return (
    <div className="h-96 relative w-full overflow-hidden bg-[#6A9C89] flex flex-col items-center justify-center ">
      <div className="absolute inset-0 w-full h-full bg-[#6A9C89] z-20 [mask-image:radial-gradient(transparent,white)] pointer-events-none" />

      <Boxes />
      <div className="relative">
        <div className="flex flex-col items-center justify-center w-full px-4 py-12 bg-transparent sm:px-6 lg:px-8">
          <h2 className="text-6xl font-bold tracking-tight text-center text-[#16423C]">
            Get in touch with us today!
          </h2>
          <p className="mt-4 text-lg text-center font-semibold text-[#16423C]">
            Connect with us to learn more about our services or visit our
            website to explore how we can help you achieve your goals.
          </p>
          <div className="flex flex-col items-center mt-8 space-y-4 sm:flex-row sm:space-y-0 sm:space-x-4 w-[100%] justify-center">
            <a
              href="https://quodata.de/form/contact-us?form="
              target="_blank"
              rel="noopener noreferrer"
              className="w-full sm:w-auto"
            >
              <button
                type="button"
                className="w-full px-4 py-3 text-base font-medium text-white bg-[#16423C] rounded-lg hover:bg-[#c4dad2] focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-[#16423C] sm:w-auto"
              >
                Get in touch
              </button>
            </a>
          </div>
        </div>
      </div>
    </div>
  );
}
